import React from "react";

const Fade = ({ in: inProp = true, children }) => (
  <>{inProp ? children : null}</>
);

export default Fade;
